(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[639],{

/***/ 1433:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company",
      function () {
        return __webpack_require__(1523);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2745:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/carousel-arrow-left.0c4f3d2f.svg","height":42,"width":42});

/***/ }),

/***/ 7935:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/carousel-arrow-right.4a5dbdbe.svg","height":42,"width":42});

/***/ }),

/***/ 8838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardHorizontal4; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(8182);
;// CONCATENATED MODULE: ./src/assets/icons/arrow-card-icon.svg
/* harmony default export */ var arrow_card_icon = ({"src":"/_next/static/media/arrow-card-icon.a14f7300.svg","height":21,"width":13});
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.module.scss
var CardHorizontal4_module = __webpack_require__(8546);
var CardHorizontal4_module_default = /*#__PURE__*/__webpack_require__.n(CardHorizontal4_module);
;// CONCATENATED MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.tsx






function CardHorizontal4(param) {
    let { sectionTitle , sectionDesc , customClass , hasArrow , items  } = param;
    const componentClass = "CardHorizontal4 ".concat((CardHorizontal4_module_default()).CardHorizontal4, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-5",
                    dangerouslySetInnerHTML: {
                        __html: sectionTitle !== null && sectionTitle !== void 0 ? sectionTitle : ""
                    }
                }),
                sectionDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-5",
                    children: sectionDesc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "mb-4 position-relative",
                            md: 6,
                            lg: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    style: {
                                        backgroundColor: "".concat(item.bgColor)
                                    },
                                    className: (CardHorizontal4_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        className: (CardHorizontal4_module_default()).cardBody,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "title",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "desc",
                                                children: [
                                                    " ",
                                                    item.desc
                                                ]
                                            }),
                                            hasArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "open-arrow position-absolute",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    source: arrow_card_icon.src
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, index)
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 1523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/assets/img/bg-about-global-team.webp
var bg_about_global_team = __webpack_require__(2472);
;// CONCATENATED MODULE: ./src/assets/img/bg-about-customer-value-img.webp
/* harmony default export */ var bg_about_customer_value_img = ({"src":"/_next/static/media/bg-about-customer-value-img.2a93222a.webp","height":781,"width":431,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSCEAAAAAAADD8gCh/8Sh/8cBqpkZALKmIgCT/9MJAJH/1wAAo7oAVlA4IGYAAABwAgCdASoEAAgAAkA4JbACdDKcv7N6gAMx1aIAAPa71z17/O4sz7QYH+S24WLGh/WU0v3wQ4/3jCBlkq2bR/W+E+uCX8vz/+Tdb3/0m95yt2b/8NjEN//1DEbwnUf/+ou+GrfIAAA=","blurWidth":4,"blurHeight":8});
// EXTERNAL MODULE: ./src/assets/img/about-casper.webp
var about_casper = __webpack_require__(6162);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Image.js
var Image = __webpack_require__(1330);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(6529);
// EXTERNAL MODULE: ./src/assets/icons/carousel-arrow-left.svg
var carousel_arrow_left = __webpack_require__(2745);
// EXTERNAL MODULE: ./src/assets/icons/carousel-arrow-right.svg
var carousel_arrow_right = __webpack_require__(7935);
// EXTERNAL MODULE: ./src/modules/teams/components/TeamCard/TeamCard.tsx + 3 modules
var TeamCard = __webpack_require__(2771);
// EXTERNAL MODULE: ./src/modules/company/components/OurLeadership/OurLeadership.module.scss
var OurLeadership_module = __webpack_require__(1401);
var OurLeadership_module_default = /*#__PURE__*/__webpack_require__.n(OurLeadership_module);
;// CONCATENATED MODULE: ./src/modules/company/components/OurLeadership/OurLeadership.tsx








const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: {
            max: 4000,
            min: 1200
        },
        items: 4
    },
    desktop: {
        breakpoint: {
            max: 1199.99,
            min: 992
        },
        items: 4
    },
    tablet: {
        breakpoint: {
            max: 991.99,
            min: 768
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 767.99,
            min: 0
        },
        items: 1
    }
};
const ButtonGroup = (param)=>{
    let { next , previous , length , ...rest } = param;
    const { carouselState: { currentSlide , deviceType  }  } = rest;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OurLeadership_module_default()).carouselButtonGroup,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                width: 42,
                height: 42,
                src: carousel_arrow_left/* default.src */.Z.src,
                alt: "left arrow",
                className: (currentSlide === 0 ? (OurLeadership_module_default()).carouselDisabled : (OurLeadership_module_default()).carouselArrow, "arrow-left"),
                onClick: ()=>previous && previous()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                width: 42,
                height: 42,
                src: carousel_arrow_right/* default.src */.Z.src,
                alt: "right arrow",
                className: (currentSlide + responsive[deviceType].items === length ? (OurLeadership_module_default()).carouselDisabled : (OurLeadership_module_default()).carouselArrow, "arrow-right"),
                onClick: ()=>next && next()
            })
        ]
    });
};
function OurLeadership(param) {
    let { list  } = param;
    const key = (0,react.useId)();
    (0,react.useEffect)(()=>{
        //lighthouse fix
        setTimeout(()=>{
            const carouselItems = Array.from(document.getElementsByClassName("react-multi-carousel-item"));
            carouselItems.filter((el)=>el.ariaHidden === "true").forEach((element)=>{
                const children = element.querySelectorAll("a");
                children.forEach((child)=>{
                    child.setAttribute("tabindex", "-1");
                });
            });
        }, 2000);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "pt-3 pt-xl-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "OurLeadership position-relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "h1 mb-lg-6",
                        children: "Our Leadership"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                        responsive: responsive,
                        arrows: false,
                        infinite: true,
                        renderButtonGroupOutside: true,
                        customButtonGroup: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                            length: list.length
                        }),
                        children: list && list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-5 m-md-4 m-lg-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamCard/* default */.Z, {
                                    item: item
                                })
                            }, key + index))
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/modules/teams/hooks/useTeamList.ts
var useTeamList = __webpack_require__(4007);
// EXTERNAL MODULE: ./src/modules/common/components/Founders/AboutFounders.tsx + 4 modules
var AboutFounders = __webpack_require__(2530);
// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/hero/Hero/Hero.tsx
var Hero = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/@shared/components/cards/CardHorizontal4/CardHorizontal4.tsx + 1 modules
var CardHorizontal4 = __webpack_require__(8838);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
;// CONCATENATED MODULE: ./src/pages/company.tsx














var __N_SSP = true;
function About() {
    const CardHorizontal4Items = [
        {
            title: "Act like an Owner",
            desc: "This is our company. We each are and act like owners. We are working for ourselves. In doing so, we are humble and quietly confident.",
            bgColor: "#BCFC07"
        },
        {
            title: "Appeal to Competence",
            desc: "We listen attentively, speak candidly, and treat others respectfully. Our words are important to communicate ideas and create synergies, but our actions speak the loudest. We lead by example.",
            bgColor: "#AD53E5"
        },
        {
            title: "Have Fortitude",
            desc: "Disagree & Align: We have convictions and are tenacious. We respectfully challenge ideas and positions. Once a decision is made, we march forth together.",
            bgColor: "#4589F6"
        },
        {
            title: "Commit to Excellence",
            desc: "We consistently exceed expectations, not just for ourselves but for each other. We focus on results over process. We don’t just meet the bar; we raise the bar.",
            bgColor: "#F622E6"
        },
        {
            title: "Learn and Grow",
            desc: "We choose to evolve. When doing so, we know that mistakes do happen. We recognize that discomfort is a part of the growing process, and we do not shy away from it.",
            bgColor: "#3EDC64"
        },
        {
            title: "Hire and Develop the Best",
            desc: "We recognize and develop exceptional talent. We embrace hiring people smarter than ourselves. Our team is our most valuable asset.",
            bgColor: "#F9AACA"
        }
    ];
    const { founders , executives  } = (0,useTeamList/* default */.Z)();
    const [showDesc, setShowDesc] = (0,react.useState)(false);
    const handleReadMore = ()=>setShowDesc(true);
    const pageClass = "aboutUsPage";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: "About Us & The Casper Team | Casper Labs",
                description: "Learn about Casper Labs, a leader in blockchain technologies, is revolutionizing industries. Casper is the first blockchain built for business adoption.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: about_casper/* default.src */.Z.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: pageClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "aboutUsPageMain",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                customClass: "pt-0 pb-0 header",
                                isHeader: true,
                                bgImage: about_casper/* default.src */.Z.src,
                                col1: 6,
                                col2: 6,
                                halfTitle: "About Us",
                                title: 'A <span class="text-green">blockchain</span> that makes sense for business',
                                desc: "Casper is the first blockchain built specifically for business adoption. Casper’s unique design allows it to adapt and endure with your business over time – and thanks to Casper Labs, organizations building on Casper always have a clear place to turn for dedicated services, support and bespoke software development."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "position-relative aboutGradient",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(framerMotion/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "customerValueImg",
                                                src: bg_about_customer_value_img.src,
                                                alt: "Casper Labs",
                                                width: 800,
                                                height: 800
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                                                customClass: "mt-0 pt-0 pb-lg-5 customerValue",
                                                colLg1: 8,
                                                colLg2: 4,
                                                col1: 8,
                                                col2: 4,
                                                childrenCol: 1,
                                                title: 'We’re <span class="text-green">building</span> the essential foundation for an entirely new era of <span class="text-green">customer value</span> and business success.',
                                                children: [
                                                    !showDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-5 btn btn-primary customerValueDesc",
                                                        onClick: handleReadMore,
                                                        children: "Read More"
                                                    }),
                                                    showDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-5",
                                                        children: "Casper Labs’ leadership team comes from enterprise technology backgrounds. We possess a deep understanding of what organizations need to succeed with emerging technology. Casper provides an unprecedented degree of customization and control than is possible on other, one-size-fits-all blockchains."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    founders && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "position-relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutFounders/* default */.Z, {
                                                founders: founders.members
                                            })
                                        })
                                    })
                                ]
                            }),
                            executives && /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurLeadership, {
                                    list: executives.members
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                    customClass: "mt-0 pt-0 pb-0 ceoMessage",
                                    col1: 11,
                                    col2: 1,
                                    title: "<blockquote>We realized that neither on the structure side nor the product side was a blockchain company or protocol that was really taking care of the needs of enterprise...that's what led me to found Casper Labs.</blockquote>",
                                    desc: "Mrinal Manohar, CEO"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                    customClass: "mt-0 pt-0 pb-0 globalTeam",
                                    colLg1: 6,
                                    colLg2: 6,
                                    title: "We are one global team",
                                    desc: "Our growing team of nearly 100 employees spans three continents and countless time zones. We’re committed to building the most reliable and sustainable blockchain for businesses by meeting organizations where they are, not vice versa.",
                                    linkButton: {
                                        label: "Join our team",
                                        link: "/careers",
                                        variant: "primary"
                                    },
                                    bgImage: bg_about_global_team/* default.src */.Z.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHorizontal4/* default */.Z, {
                                    hasArrow: true,
                                    customClass: "ourValuesSection pt-8 pb-7",
                                    sectionTitle: "Our Values",
                                    sectionDesc: "We enjoy a low turnover rate and high employee satisfaction due to our core values - we stay true to them through everything that we do.",
                                    items: CardHorizontal4Items
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                col1: 5,
                                col2: 7,
                                title: "Sign up for our newsletter!"
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 8546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CardHorizontal4_card__GgvZS","cardBody":"CardHorizontal4_cardBody__LjhE_"};

/***/ }),

/***/ 1401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselDisabled":"OurLeadership_carouselDisabled__MkqSJ","carouselArrow":"OurLeadership_carouselArrow__YXJAI","carouselButtonGroup":"OurLeadership_carouselButtonGroup__PDHJ8"};

/***/ }),

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(9602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(9059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 1330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





const propTypes = {
  /**
   * @default 'img'
   */
  bsPrefix: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),

  /**
   * Sets image as fluid image.
   */
  fluid: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as rounded.
   */
  rounded: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as circle.
   */
  roundedCircle: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};
const defaultProps = {
  fluid: false,
  rounded: false,
  roundedCircle: false,
  thumbnail: false
};
const Image = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  fluid,
  rounded,
  roundedCircle,
  thumbnail,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'img');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
    // eslint-disable-line jsx-a11y/alt-text
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
  });
});
Image.displayName = 'Image';
Image.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Image);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,675,529,27,774,888,179], function() { return __webpack_exec__(1433); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);